import { AREAS_OLEOS } from '@/utils/referenciaOleos'

const TEXTO_ORIENTACAO = `Leia antes do atendimento. Use esta tabela para identificar qual óleo apresentar primeiro para a cliente. Comece sempre pelo primeiro da lista de cada área. Você pode indicar a compra do Kit Brasil que atende a todas as demandas dela neste momento, bem como para suporte diário. Pode também indicar um, dois ou a quantidade que for a prioridade de suporte para a cliente. Uma boa forma de começar é observar a prioridade da cliente e indicar pelo menos um óleo essencial relaxante e outro energizante. O protocolo de uso dos óleos essenciais deve ser apresentado apenas quando os óleos essenciais forem comprados.`

export default function ReferenciaRapidaOleos() {
  return (
    <div className="mb-8">
      <h3 className="text-2xl font-cormorant font-semibold text-verde-escuro mb-4 pb-3 border-b-2 border-verde-escuro">
        Referência Rápida de Óleos
      </h3>
      <div
        className="p-4 rounded-xl mb-5 text-sm leading-relaxed"
        style={{ backgroundColor: '#F8F4EF', border: '1px solid #EDE0D4', color: '#5F5E5A' }}
      >
        {TEXTO_ORIENTACAO}
      </div>
      <div className="overflow-x-auto rounded-xl border" style={{ borderColor: '#EDE0D4' }}>
        <table className="w-full text-sm">
          <thead style={{ backgroundColor: '#D8F3DC' }}>
            <tr>
              <th className="px-4 py-3 text-left font-medium text-verde-escuro">Área</th>
              <th className="px-4 py-3 text-left font-medium text-verde-escuro">Prioridade de óleos</th>
              <th className="px-4 py-3 text-left font-medium text-verde-escuro">Orientação</th>
            </tr>
          </thead>
          <tbody>
            {AREAS_OLEOS.map((area, idx) => (
              <tr
                key={area.id}
                style={{ backgroundColor: idx % 2 === 0 ? '#FFFFFF' : '#F8F4EF' }}
              >
                <td className="px-4 py-3 align-top text-texto-escuro font-medium">
                  <span className="mr-1">{area.emoji}</span>
                  {area.titulo}
                </td>
                <td className="px-4 py-3 align-top text-texto-escuro">
                  {area.oleos.join(' → ')}
                </td>
                <td className="px-4 py-3 align-top text-texto-suave">
                  {area.orientacao || '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
